module.exports = __webpack_public_path__ + "img/new-forest.2.785d235.jpg";